// Implements: F-IDN-010
/**
 * "Cerrar las demás sesiones" (`POST /auth/sessions/revoke-others`). The list is refreshed from the
 * server afterwards, so the rows disappear because the server closed them, never optimistically.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationResult } from "@tanstack/react-query";

import type { ApiError } from "../../../shared/api/ApiError";
import { AUTH_SESSIONS_KEY } from "../../../shared/api/queryKeys";
import type { RevokeOthersResponse } from "../../../types/api";
import { revokeOtherSessions } from "../api/accountApi";

export function useRevokeOthers(): UseMutationResult<RevokeOthersResponse, ApiError, null> {
  const client = useQueryClient();
  return useMutation<RevokeOthersResponse, ApiError, null>({
    mutationFn: () => revokeOtherSessions(),
    onSuccess: async () => {
      await client.invalidateQueries({ queryKey: AUTH_SESSIONS_KEY });
    },
  });
}
